import { render, staticRenderFns } from "./PrintOrderCopyRecipientAddForm.vue?vue&type=template&id=5b2692fe&scoped=true"
import script from "./PrintOrderCopyRecipientAddForm.vue?vue&type=script&lang=js"
export * from "./PrintOrderCopyRecipientAddForm.vue?vue&type=script&lang=js"
import style0 from "./PrintOrderCopyRecipientAddForm.vue?vue&type=style&index=0&id=5b2692fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b2692fe",
  null
  
)

export default component.exports